<template>
  <div id="wrapper" ref="lumaempty">

    <luma-sidebar @updatePage="updatePage"></luma-sidebar>


    <div id="page-wrapper" class="gray-bg">
      <div class="row border-bottom">
        <nav class="navbar navbar-static-top" role="navigation" style="margin-bottom: 0">
          <div class="navbar-header">
<!--            <a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="#"><i class="fa fa-bars"></i> </a>-->
          </div>
          <ul class="nav navbar-top-links navbar-right">
            <li>
              <a href="/" @click="logout()">
                <i class="fa fa-sign-out"></i> Abmelden
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div class="row wrapper border-bottom white-bg page-heading">
        <div class="col-sm-4">
          <h2>{{ $t('sidebar.' + this.routeName +'.label') }}</h2>

          <ol class="breadcrumb">
            <li class="breadcrumb-item" :class="{active: this.package === undefined}">
              <router-link :to="{ name: 'general-dashboard'}">Home</router-link>
            </li>
            <li class="breadcrumb-item active" v-if="this.package !== undefined">
              <strong>{{ $t('sidebar.' + routeKey[0] + '.'+routeKey[1] ) }}</strong>
            </li>
          </ol>
        </div>
      </div>

      <div class="wrapper wrapper-content">
        <b-container style="min-width: 432px;">
          <slot v-if="!pageUpdate" ></slot>
        </b-container>
      </div>
      <div class="footer">
        <div>
          <strong>Copyright</strong> &copy; 2016 - 2020 by LUMASERV Systems
        </div>
      </div>

    </div>

  </div>
</template>

<script>
  import LumaSidebar from "@/layout/LumaSidebar";
  export default {
    name: "luma-empty",
    components: {
      LumaSidebar
    },
  data:()=>({
     pageUpdate:false
  }),
    computed: {
      package() {
        return this.$route.meta.package
      },
      routeName() {
        return this.$route.meta.key
      },
      routeKey() {
        const x = this.$route.name.split('-')
        return x
      }
    },
    methods: {
      logout: function() {
        return this.$store.dispatch("users/logout")
      },
      updatePage(val){
          this.pageUpdate = true
          setTimeout(()=>{
              console.log('UPDATEPAGE 111')
              this.pageUpdate = false
          },200)

      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/LumaEmpty.vue